import FleetCoachDriverMapping from "../../../views/FleetCoachDriverMapping";
import FleetCoachDriverMappingV2 from "../../../views/FleetCoachDriverMappingV2";
import MenuNames from "../../../constants/Menu/MenuNames.json";

const FleetCoachDriverMappingRoutes = [
  {
    menuName: MenuNames.FLEET_COACH,
    path: "/fleet-coach-driver-mapping",
    component: FleetCoachDriverMapping,
    exact: true,
  },
  {
    menuName: MenuNames.FLEET_COACH_V2,
    path: "/v2/fleet-coach-driver-mapping",
    component: FleetCoachDriverMappingV2,
    exact: true,
  },
];

export default FleetCoachDriverMappingRoutes;
